// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyD0w779W3GKB65gN_Ddn7Ykcj52NMByXj8",
  authDomain: "pronest-35556.firebaseapp.com",
  projectId: "pronest-35556",
  storageBucket: "pronest-35556.firebasestorage.app",
  messagingSenderId: "686563290547",
  // Note: For Web apps, generate a Web App in Firebase Console -> Project Settings -> General -> Your apps -> Web (</>)
  appId: "1:686563290547:android:f41c9acce02c16aa46afc6",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export { RecaptchaVerifier, signInWithPhoneNumber };

